import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Navbar from './components/Navbar';
import Home from './pages/Home';
import PostDetail from './pages/PostDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Admin from './pages/Admin';
import AdPage1 from './pages/AdPage1';
import AdPage2 from './pages/AdPage2';
import SocialBarAd from './components/SocialBarAd';
import PopUnderAd from './components/PopUnderAd';
import SearchResults from './pages/SearchResults'; // Add import
import './styles/App.css';

function App() {
  return (
    <Router>
      <div className="App">
        {/* <Navbar /> */}
        <PopUnderAd />
        <SocialBarAd /> {/* ဒါဆို စာမျက်နှာတိုင်းမှာ Social Bar ပေါ်ပါမယ် */}
        {/* Routes... */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/link1" element={<AdPage1 />} />
          <Route path="/link2" element={<AdPage2 />} />
          <Route path="/ad1" element={<AdPage1 />} />
          <Route path="/ad2" element={<AdPage2 />} />
          <Route path="/post/:id" element={<PostDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/search" element={<SearchResults />} /> {/* Add this route */}

        </Routes>
      </div>
    </Router>
  );
}

export default App;
